import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IBOMVaccineFamilyDoseResponse } from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { setBomVaccineFamilyDose } from "@/app_redux/reducers/slices/auth/inventory_slice";

AxiosCurlirize(axios, () => {});

export const useBOMVaccineFamilyDoseAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(async (petSpecies?: string) => {
    dispatch(
      setLoading({
        key: "isInventoryServiceListLoadingInProgess",
        status: true,
      }),
    );
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const url = petSpecies
        ? `${INVENTORY_MODULE?.BOM_VACCINE_FAMILY_DOSE?.baseURL}?pet_species=${encodeURIComponent(petSpecies)}`
        : `${INVENTORY_MODULE?.BOM_VACCINE_FAMILY_DOSE?.baseURL}`;
      await axios
        .get(url, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IBOMVaccineFamilyDoseResponse>) => {
          if (res.data.status === true) {
            dispatch(setBomVaccineFamilyDose({ data: res.data.data }));
            dispatch(
              setLoading({
                key: "isInventoryServiceListLoadingInProgess",
                status: false,
              }),
            );
          } else {
            dispatch(setBomVaccineFamilyDose({ data: [] }));
            dispatch(
              setLoading({
                key: "isInventoryServiceListLoadingInProgess",
                status: false,
              }),
            );
          }
        })
        .catch((e: AxiosError) => {
          dispatch(setBomVaccineFamilyDose({ data: [] }));
          sendCurl(e.config["curlCommand"]);
        });
    } catch (error) {
      dispatch(setBomVaccineFamilyDose({ data: [] }));
      dispatch(
        setLoading({
          key: "isInventoryServiceListLoadingInProgess",
          status: false,
        }),
      );
      if (axios.isAxiosError(error)) {
        captureError(error);
      } else {
        toast.error("Server Error: " + error.message);
      }
    }
  }, [dispatch, configuration]);

  return execute;
};
